import { MedalliaState } from '@core/medallia/store/states/medallia.state';

export const medalliaState = [MedalliaState];
